import { ArrowRight, Check, FileCheck, MessageSquare, ShieldCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CHECKLIST = [
  {
    title: 'Dokumentationsentwurf statt Entscheidung',
    detail: 'Icarus D&D strukturiert Gesprächsinhalte und markiert Quellenstellen. Fachliche Bewertung und Freigabe bleiben beim Menschen.',
  },
  {
    title: 'GNCP als Werkbank',
    detail: 'Assessment kann vorbereitet werden; Diagnose, Intervention und Monitoring werden im öffentlichen MVP nicht automatisch vorgeschlagen.',
  },
  {
    title: 'Praxis-MVP statt Klinikversprechen',
    detail: 'Der öffentliche Rollout fokussiert ambulante Praxisabläufe: Akte, Termine, Teletherapie, Portal, Rechnungen und Nachrichten.',
  },
  {
    title: 'Auditierbare Nutzung',
    detail: 'Entwürfe, Freigaben und Änderungen bleiben nachvollziehbar und können im Praxisbetrieb geprüft werden.',
  },
];

export const KhagCompliance = () => (
  <section id="public-mvp-scope" className="py-20 border-y border-border/50">
    <div className="max-w-6xl mx-auto px-6">
      <div className="grid lg:grid-cols-2 gap-12 items-start">
        <div>
          <div className="inline-flex items-center gap-2 bg-primary/10 border border-primary/20 text-primary text-xs font-semibold px-3 py-1.5 rounded-full mb-4">
            <ShieldCheck className="w-3 h-3" />
            Öffentlicher MVP-Scope
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-foreground tracking-tight">
            Assistenz, nicht Vorentscheidung.
          </h2>
          <p className="mt-3 text-gray-700 leading-relaxed max-w-lg">
            Icarus D&D wird öffentlich als Praxis-Schaltzentrale und Dokumentationsassistent
            ausgeliefert. Die KI darf vorbereiten, sortieren und formulieren, aber keine
            Diagnose-, Therapie-, Risiko- oder Priorisierungsentscheidung treffen.
          </p>

          <div className="mt-8 space-y-4">
            {CHECKLIST.map(({ title, detail }) => (
              <div key={title} className="flex items-start gap-3">
                <FileCheck className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-semibold text-foreground">{title}</p>
                  <p className="text-xs text-gray-600 mt-0.5 leading-relaxed">{detail}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <a href="mailto:info@icarus-health.de?subject=D%3AE%3AF%3AY%20Demo-Anfrage">
              <Button size="lg" className="bg-primary hover:bg-primary/90 text-white rounded-xl text-base px-6 h-12">
                <MessageSquare className="w-4 h-4 mr-2" />
                Demo anfragen
              </Button>
            </a>
            <a href="#preise">
              <Button size="lg" variant="outline" className="rounded-xl text-base px-6 h-12">
                Pakete ansehen
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </a>
          </div>
        </div>

        <div className="lg:sticky lg:top-24">
          <div className="bg-secondary/20 rounded-2xl border border-border p-6 md:p-8">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
                <ShieldCheck className="w-5 h-5 text-primary" />
              </div>
              <div>
                <p className="text-xs text-muted-foreground font-medium uppercase tracking-wide">Produktgrenze</p>
                <h3 className="font-bold text-foreground">Was Icarus D&D im MVP nicht tut</h3>
              </div>
            </div>

            <div className="space-y-4">
              <div className="bg-card rounded-xl border border-border p-4">
                <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-2">Nicht automatisch</p>
                <div className="flex flex-wrap gap-2">
                  {['Diagnose', 'Therapieempfehlung', 'Risikostufe', 'Priorisierung'].map(s => (
                    <span key={s} className="inline-flex items-center gap-1 bg-secondary/60 text-foreground text-xs font-semibold px-2.5 py-1 rounded-full">
                      <Check className="w-3 h-3" />
                      {s}
                    </span>
                  ))}
                </div>
              </div>

              <div className="rounded-xl border border-primary/20 bg-primary/5 p-4">
                <p className="text-xs font-semibold text-primary mb-1">Nutzerfreundlichkeit bleibt</p>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  Der Workflow bleibt schnell, weil Icarus D&D die Roharbeit übernimmt:
                  transkribieren, sortieren, formulieren und offene Felder für die
                  fachliche Eingabe klar anzeigen.
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
);
